import MultiSelect from "components/common/MultiSelect";
import { GetInsuranceList } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import ExcelUploadCard from "features/practitioner/components/ExcelUploadCard";
import { InfoAlert } from "features/practitioner/utils";
import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ExcelPriceUpload from "./ExcelPriceUpload";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";

const PriceUploadStep = ({ control, watch, setValue, errors }) => {
  const dispatch = useDispatch();
  const { poyerList } = useSelector((state) => state.eligibilityCheckList);
  const { allPermissionType } = useSelector((state) => state.role);
  const priceSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Price"
  );
  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, [poyerList]);

  // Handle template download
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Price_List_Template.xlsx`;
    link.download = "Price_List_Template.xlsx";
    document.body.appendChild(link); // for Safari support
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Row>
      <Col xs={12}>
        <InfoAlert>
          Download the template, fill it with your data, select the payer then
          upload to begin the mapping process.
        </InfoAlert>
      </Col>
      <Row>
        <Col xs={12} md={6} xl={4}>
          <label className="form-label">Payer</label>
          <Controller
            name="payer"
            control={control}
            rules={{ required: "Payer is required" }}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  options={poyerList?.map((item) => ({
                    value: item.payer_id,
                    label: item.payer_name,
                  }))}
                  isClearable={true}
                  value={
                    field?.value
                      ? {
                          value: field.value.payer_id,
                          label: field.value.payer_name,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "payer",
                      selected
                        ? {
                            payer_id: selected?.value,
                            payer_name: selected?.label,
                          }
                        : null
                    );
                  }}
                  className={error ? "is-invalid" : ""} // Add error class
                  formatOptionLabel={({ label }) => <div>{label}</div>}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
                {error && (
                  <div className="text-danger mt-2">{error.message}</div>
                )}
              </>
            )}
          />
        </Col>
        <Col xs={12} md={6} xl={4}>
          <Card className="mt-3">
            <Card.Body className="text-center d-flex flex-column justify-content-between h-100">
              <div>
                <div
                  className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center mb-3 justify-content-center mx-auto mb-3"
                  style={{ width: 80, height: 80 }}
                >
                  <Download size={28} />
                </div>
                <h5 className="fw-bold mb-2">Excel Template</h5>
                <p className="text-muted mb-4">
                  Download our preformatted Excel template to ensure your data
                  is structured correctly
                </p>
              </div>
              <div className="mt-3 d-flex justify-content-center">
                <Button
                  variant="primary"
                  className="d-flex align-items-center justify-content-center"
                  onClick={handleDownloadTemplate}
                >
                  Download Template
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6} xl={4}>
          {priceSetting?.import ? (
            <ExcelPriceUpload
              watch={watch}
              control={control}
              setValue={setValue}
              errors={errors}
              name="excelFile"
            />
          ) : (
            <div className="text-center py-6">
              You don't have a permission to import price
            </div>
          )}
        </Col>
      </Row>
    </Row>
  );
};

export default PriceUploadStep;
